export default __webpack_public_path__ + "static/media/Gorulga's Mark.79ea4c90.jpg";